import React from 'react';
import Header from './Header';
import Footer from './Footer';
import WhatsAppButton from '../common/WhatsAppButton';
import PhoneButton from '../common/PhoneButton';

const Layout = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-grow pt-20">
        {children}
      </main>
      <Footer />
      
      {/* Sticky Contact Buttons */}
      <div className="fixed bottom-6 right-6 z-[99] space-y-3 flex flex-col lg:flex-col xl:space-y-4 animate-in slide-in-from-bottom-2 duration-500">
        <PhoneButton />
        <WhatsAppButton />
      </div>
    </div>
  );
};

export default Layout;
